import { growthbook } from './services/growthbook/growthbook';
import { IS_DEV, USER_DATA } from './constants/common';
import { sentry } from './services/sentry/sentry';
import analytics from './services/analytics';
import { getLSValue } from './utils/locale-storage';
import { UserLocalStorageData } from './types/user';

const userLSData = getLSValue(USER_DATA, true) as UserLocalStorageData;
const queryParams = Object.fromEntries(new URLSearchParams(window.location.search));

const userId = userLSData?.user_id || queryParams?.customer_id || '';

if (process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY) {
  growthbook.setUp(process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY, [
    (experiment, result): void => {
      if (IS_DEV) {
        // eslint-disable-next-line no-console,@typescript-eslint/no-unsafe-assignment
        console.log('[Feature]', { experiment, result: result?.value });
      }
    },
  ]);
}

if (process.env.REACT_APP_SENTRY_DSN) {
  sentry.init(process.env.REACT_APP_SENTRY_DSN);
}

analytics.init({
  userId: userId,
  userProperties: {
    ...(userId ? { customer_id: userId } : {}),
    campaign: queryParams?.utm_campaign || 'none',
    content: queryParams?.utm_content || 'none',
    source: queryParams?.utm_source || 'none',
    lang: queryParams?.utm_lang || 'none',
  },
  onInitEvent: {
    name: 'quiz_load',
    params: {
      domain: window.location.hostname,
      previous_domain: window.document.referrer,
      utm_source: queryParams?.utm_source || 'none',
      query_string: window.location.search,
    },
  },
});
